module.exports = {"TXTWCL_Unlock":{"id":"TXTWCL_Unlock","defaultMessage":"Freischalten","flags":["TRACK"],"track":"Unlock"}}